'use client';
import { OrGlobalBanner } from './or-global-banner';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { IGlobalBannerCsProps } from './or-global-banner.types';
import { useState, useEffect } from 'react';

export const OrGlobalBannerCMS = ({ block }: IGlobalBannerCsProps) => {
  const { content, cta, asset } = block;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient) {
    return (
      <OrGlobalBanner cta={cta} asset={asset}>
        Loading...
      </OrGlobalBanner>
    );
  }

  return (
    <OrGlobalBanner cta={cta} asset={asset}>
      {content ? (
        <RenderRichText body={content} useProse={false} />
      ) : (
        <p>Loading...</p>
      )}
    </OrGlobalBanner>
  );
};
